const three = (
  <div>
    <h2 id="a-place-to-stay">Settling In</h2>
    <p>
      Myles woke to a soft intentional cough, and blearily opened his eyes to
      see Ms. Lenore smiling slightly at him.
    </p>
    <p>
      &quot;Shower when you're up, there's no hurry.&quot; She said, walking off
      to begin preparing the custom order potions.
    </p>
    <p>
      He rose blinking, realizing that he had overslept and killed the pretense
      that he was sleeping at his home. The hot water in the shower was
      refreshing, he hadn't taken a shower in over three days and being clean
      felt good. Myles was less thrilled about putting on his robes, which
      smelled after three days of being constantly worn and three days before
      that of daytime wear. Nevertheless, he put them on and went to see if Ms.
      Lenore could use help. She handed him a note and a check and told him to
      go to Malkin's Robes, saying he needed to look presentable to work the
      desk.
    </p>
    <p>
      Malkin's was not as bright or colorful as many of the other places on
      Diagon Alley but it's darker tones and organized appearance gave it a more
      serious and respectable tones. He was not surprised to see a pair of
      children his age standing inside. They were dressed in some of the finest
      robes he'd seen and stood in a rather imperious fashion, with their heads
      up high and looking around the shop with vague disinterest and
      entitlement. He wondered if they were twins, the boy's hair was white
      while the girl's was dark brown but they stood like they were a pair and
      looked to be the same age.
    </p>
    <p>
      Myles approached the deck and gave his note and check to the clerk, who
      told him to wait and that &quot;We'll be with you shortly.&quot; The twins
      wrinkled their noses at him as he passed, though the way his robes smelled
      he could hardly blame them.
    </p>
    <p>
      &quot;Are you getting Hogwarts robes?&quot; the boy asked, in a superior
      but not unkind manner.
    </p>
    <p>
      Myles nodded, certain that claiming he wasn't going to Hogwarts would
      raise more questions than it answered. &quot;You as well?&quot; he
      replied, a little surprised the boy was talking to him even if only out of
      boredom.
    </p>
    <p>
      The boy nodded back and held his hand out to shake. &quot;Ambrose
      Malfoy.&quot; He pronounced the Malfoy with particular pride and looked at
      Myles expectantly as he said it.
    </p>
    <p>&quot;Myles.&quot; he returned.</p>
    <p>
      &quot;This is my twin sister Ambrosia, we'll be attending Hogwarts next
      year.&quot; Ambrose said, clearly perturbed at his complete nonreaction
      and short introduction. Ambrosia nodded to him in greeting and then
      Ambrose and Ambrosia were called to the fitting rooms.
    </p>
    <p>
      Myles didn't think much about his encounter with the Malfoy twins, except
      to wonder if children were the same outside of the Orphanage. He got
      fitted for a pair of robes, not as fancy as the Malfoy's but certainly
      nicer than the old robes he had been wearing and returned to Beth's,
      feeling a bit guilty that Ms. Lenore was now feeding, clothing, and
      housing him and he was of so little help in return.
    </p>
    <p>
      The bell rang as he entered and Ms. Lenore approached him as he made his
      way to the back. She smiled wide, wider than he had seen smile before and
      crouched down in front of him.
    </p>
    <p>
      &quot;You're a very handsome boy you know, all cleaned up and properly
      dressed.&quot; Myles blushed, looking down and Ms. Lenore's feet. It
      seemed She fussed with his hair, arranging it into neat curls with her
      hands and a light buzz of magic on her fingertips. Myles almost brushed
      her hands away at first, but the genuine smile on her face stopped him and
      a part of him realized how much he had enjoyed the attention afterwards.
    </p>
    <p>
      He began the short list of chores he could do while Ms. Lenore saw to
      clients, taking a particularly long time with a patient who had somehow
      managed to cast a charm that produced bubbles inside herself, posing a
      critical threat to her lungs and brain.
    </p>
    <p>
      When Ms. Lenore went on an &quot;Urgent&quot; house call (a meter above
      the fireplace eater house calls request from &quot;At Convenience&quot; to
      &quot;Emergency&quot;), minded the desk and, having only a brief encounter
      with one customer, returned to reading the Introductory healing book he
      had begun last night. Myles was still reading it, wand out and practicing
      the wand motions for healing spell intended for splintered bones when Ms.
      Lenore returned. He quickly put away his wand and moved the book aside,
      unsure if Ms. Lenore wanted him studying while minding the desk and aware
      he hadn't even asked permission to read the book.
    </p>
    <p>
      She noticed him putting the book and wand away and smiled while he mumbled
      apologies. &quot;Nonesense, a healer's assistant should learn to heal. Let
      me see what you've read so far.&quot;
    </p>
    <p>
      Myles showed Ms. Lenore how much he had read and she seemed impressed, if
      a little skeptical. &quot;Well,&quot; she said, flipping to one of the
      simplest spells in the book which healed small cuts. &quot;Let's see if
      you can cast some of these spells.&quot;
    </p>
    <p>
      Myles's eyes widened with surprise and excitement and Ms. Lenore went to
      fetch a healing practice prop, a construct in the shape of an arm that
      imitated skin, bones, and muscles for the purpose of practicing healing.
      He hadn't never practiced real spells before, with matching incantation
      and wand motions and was excited to both use his new wand and learn magic.
    </p>
    <p>
      &quot;Okay, now recite the incantation to me without using your
      wand.&quot; She instructed.
    </p>
    <p>&quot;Nits&quot; he pronounced.</p>
    <p>&quot;Very good, but shorten the s just a smidge. Try again.&quot;</p>
    <p>&quot;Nits&quot; he tried again.</p>
    <p>
      &quot;Excellent, now show the wand movements without the
      incantation.&quot; Myles performed the small downward facing crescent
      motion followed by the slide to center required for the spell. Ms. Lenore
      looked at his wand interestedly, but didn't mention it's odd appearance.
    </p>
    <p>
      &quot;Perfect,&quot; Ms. Lenore said, drawing a knife and nicking the arm.
      &quot;Now let's try combining the two.&quot;
    </p>
    <p>
      Myles pointed his wand at the cut and executed the spell. It sewed back
      together in the blink of an eye, leaving him ecstatic in his success at
      casting his first real spell.
    </p>
    <p>
      &quot;Well done Myles,&quot; Ms. Lenore said. &quot;Few wizards or witches
      your age can learn spells on their first try. Let's do some more.&quot;
    </p>
    <p>
      Myles practiced more spells from the book with Ms. Lenore tutoring him on
      the motions and incantations. He performed almost every spell on his first
      try, after Ms. Lenore checked his wand motions and pronunciations. She was
      surprised when he managed the Bone-Setting and Bone-Mending Spells, asking
      if he had experience with healing magic before. Their tutoring session was
      interrupted when the the entryway bell rang, signaling a customer entering
      the shop.
    </p>
    <p>
      &quot;That was extremely impressive Myles.&quot; Ms. Lenore said
      earnestly. &quot;We'll continue later. Would you put the practice arm in
      the back by the Restricting Bandages and clean up the cauldron and counter
      for me?&quot;
    </p>
    <p>
      Myles thought about the different feel of casting magic with real spells
      and a functional wand. Livian and him had discovered they could cast magic
      non accidentally and with greater effect when they intentionally cut
      themselves, though oftentimes nothing happened at all. Casting blood magic
      had felt like guiding a river he couldn't see or hear and that was filled
      with a liquid far slippier than water.
    </p>
    <p>
      Magic with the wand he had made, and without real incantations or wand
      motions, had failed more often than not. When it did work it felt like the
      river was being roughly thrown into the wand and haphazardly traveling
      through it.
    </p>
    <p>
      Myles could barely feel the magic casting the spells detailed in the
      healing book with his new wand. The river was neatly guided into the wand,
      and channeled flawlessly through, its flow so subtle it was barely
      indiscernible. It felt odd, after struggling with magic for so long, to
      perform it so easily, as if the spell was doing the magic for him and he
      was only a spectator.
    </p>
    <p>
      Ms. Lenore was occupied treating clients until lunch time, when a late
      middle-aged woman arrived. She was carrying, or rather levitating, a large
      dish of shepherd's pie in front of her and held a friendly smile on her
      face that covered for the dark black scar that ran down her cheek.
    </p>
    <p>
      &quot;How are you Jay?&quot; she asked, setting the dish down on the desk.
    </p>
    <p>
      &quot;Splendid, Myra.&quot; Ms. Lenore replied, smiling back at the older
      woman. &quot;Is Lyla still well?&quot;
    </p>
    <p>
      &quot;She's never been better, you're a miracle worker. Joseph and I can't
      thank you enough for what you did. If you ever need anything from us, just
      ask and we'll be there.&quot;
    </p>
    <p>
      &quot;I was just doing my job.&quot; Ms. Lenore said dismissively.
      &quot;This is my assistant Myles, Myles this is Mrs. Laughlin. She brought
      those sandwiches yesterday and her daughter Lyla is your age.&quot;
    </p>
    <p>
      &quot;The sandwiches were amazing.&quot; Myles said enthusiastically to
      Mrs. Laughlin.
    </p>
    <p>
      &quot;I hope you'll like my pie as much.&quot; She laughed, seeing the
      look he was giving the hot dish on the desk. Ms. Lenore invited Mrs.
      Laughlin to eat with them but she politely refused and Myles and Ms.
      Lenore ate, enjoying the shepherd's pie that was every bit as good as
      sandwiches and more.
    </p>
    <p>
      The rest of the day passed much the same as the day before, with the
      exception that Ms. Lenore and Myles did not go out for ice cream. Myles
      did minor work around the shop and minded the desk when needed, and Ms.
      Lenore taught him a Heating Charm he could use on the leftover pie.
    </p>
    <p>
      This formed into a routine in the next few days. He learned potions basics
      so he could fetch ingredients and help prepare them, scourgify and other
      household spells, and continued reading and practicing healing from the
      textbook he had begun reading (which was much slower going as it became
      much more difficult). Myles was fascinated watching Ms. Lenore treat
      patients, who had all sorts of magical and physical ailments: from giant
      glowing green blisters covering their body and a scaly tongue to the
      wizards flu. She worked wonders, transforming their bodies back to
      normalcy in mere moments. It motivated him to improve at and understand
      the intricacies of healing magic.
    </p>
    <p>
      He got his first chance to attempt a healing spell for real one afternoon
      when a young girl walked into Beth's. She was in a state of total
      disorder: her hair wild and tied carelessly back, her robes dity, her
      hands scraped red, one ear was twice as big as the other and looped over
      itself, and a rash of red ran down her face on the same side as the overly
      large ear. She held a large color morphing cat in her arms, which were
      shaking from the weight of it. The girl was looking down at the rainbow of
      fluffy with a combination of worry and devotion.
    </p>
    <p>
      &quot;Ms. Lenore!&quot; she exclaimed. &quot;Scufy took a fall and now he
      won't walk right.&quot;
    </p>
    <p>
      &quot;Well, set her down then.&quot; Ms. Lenore gestured to the desk and
      looked at the girl with a mixture of amusement and fondness. &quot;You
      know your mother doesn't approve of you playing hexem with the local boys
      Lyla.&quot;
    </p>
    <p>&quot;I won though!&quot; Lyla said with a fierce stubborn pride.</p>
    <p>
      &quot;And is that how Scufy became hurt and your face lost its sense of
      proportions?&quot; Ms. Lenore asked severely, though Myles could see she
      was hiding a grin.
    </p>
    <p>
      Lyla now looked suitably abashed. &quot;It wasn't Scufy's fault though
      ma'm. Please heal him, something's wrong with his leg and he can't walk. I
      won't get him involved in hexem again.&quot; Myles noticed that she did
      not include herself in her promise.
    </p>
    <p>
      Ms. Lenore cast a diagnostic spell on the Scufy's blood matted leg and
      then called to Myles. &quot;This is perfect for you, he has a neatly
      fractured tibia and an easily manageable cut on the side of his leg. Lyla,
      you're going to need to hold him down while Myles heals him.&quot;
    </p>
    <p>
      The girl nodded and looked at him with absolute confidence, which greatly
      heightened the nerves building in his stomach at the prospect of healing a
      living creature for the first time. Nevertheless, Myles approached the
      large cat (now gray with the ends of it's hair flickering amber) and drew
      his wand.
    </p>
    <p>
      &quot;Let's heal the bone first.&quot; Ms. Lenore instructed. &quot;Let me
      hear you incante and see the motions before casting.&quot;
    </p>
    <p>
      &quot;<span style={{ fontStyle: "italic" }}>Meithis</span>&quot; Myles
      nervously but firmly pronounced.
    </p>
    <p>
      &quot;Very good, now the motions.&quot; Myles demonstrated the wand
      motions. &quot;Perfect, now together on Scuffy's leg.&quot;
    </p>
    <p>
      Myles took a deep breath, and then another, before pointing his wand at
      Scuffy's leg clearly stating the incantation and performing the tight
      swirl and flick of his wand that the bone mending charm required. He was
      alarmed at the cat's resulting screech but relieved at Ms. Lenore's proud
      smile. &quot;Very well done, now treat the cut.&quot;
    </p>
    <p>
      &quot;<span style={{ fontStyle: "italic" }}>Nits</span>.&quot; Myles cast,
      much more confident in the simpler spell.
    </p>
    <p>
      'I couldn't have done better myself.&quot; Ms. Lenore declared, cleaning
      the blood out of the cat's fur with a wave of her wand, and rising from
      her chair. &quot;Now come here dear, I can't let you walk around with your
      face in such a mess.&quot;
    </p>
    <p>
      Ms. Lenore's wand waved three times, and Lyla's ear shrunk back to normal
      size, her skin returned to its normal complexion, the scrapes on her hands
      disappeared, and, in the midst of these changes, her hair and robes
      arranged themselves in an orderly fashion. The process looked
      discomforting for Lyla, but she bore it without flinching, looking as if
      this happened often.
    </p>
    <p>
      &quot;Thank you ma'm, Scuffy and I won't forget it.&quot; she said,
      caressing her cat's fur and whispering soft reasurrences into its ear.
      Scuffy gave Myles the evil eye, apparently deciding to blame him for the
      pain of the healing spells but not the actual healing.
    </p>
    <p>
      &quot;Myles and I were about to go out for ice cream if you'd like to join
      us Lyla.&quot; Ms. Lenore said, catching Myles unawares and lighting up
      Lyla's eyes.
    </p>
    <p>
      &quot;Ice cream!&quot; she exclaimed, before remembering something
      disappointing. &quot;I don't have any money though.&quot;
    </p>
    <p>
      &quot;It'll my treat.&quot; Ms. Lenore informed the girl. &quot;Just give
      us a moment to clean up.&quot;
    </p>
    <p>
      Lyla beamed up happily at Ms. Lenore and the four of them, including Scufy
      (who was still giving Myles mistrustful looks), left the shop a few
      minutes later and headed to Florean's. Mr. Florean was absent from the
      shop, and they ordered ice cream cones of varying flavors. Myles tried out
      Typhoon, a light blue cream with brightly colored fish shaped sprinkled
      swimming through it, while Lyla ordered Snapping Strawberry, despite the
      clerk's warning that some found the &quot;snap&quot; to be unpleasant on
      their tongues, and Ms. Lenore had Witch's Ice, a rather plain appearing
      white ice cream.
    </p>
    <p>They found a table outside, having decided to enjoy the fair weather</p>
    <p>
      An old witch hailed Ms. Lenore as they found a table outside, and, in
      greeting, was pulled into a conversation, leaving Myles and Lyla sitting
      across from each other. Scuffy situated himself on Lyla's lap, his gaze
      shifting back and forth from Myles to the ice cream cone in his owner's
      hand, his color changing from the dark black and red tones of his
      suspicious watchfulness, to softer pink and yellow hues as he eyed the ice
      cream cone.
    </p>
    <p>
      &quot;What's hexem?&quot; Myles asked Lyla, wondering about her oversized
      ear and large rash before coming into Beth's earlier. The girl gave him a
      look that managed to be disgruntled, worrying, accusing, and indignant all
      at once.
    </p>
    <p>
      &quot;Hexem,&quot; Lyla declared, straightening up in her chair and
      tilting her head imperiously. &quot;Is war. A trial of valor and skill, in
      which only the last standing proves victorious.&quot; Scufy, either
      agreeing with which on the importance of hexem or simply mimicking its
      owner's attitude, reared his head and flared it's coat purple and white.
      Lyla shifting in her seat, however, had brought the ice cream cone
      dangerously close to Scuffy's mouth and he, with his coat flaring red,
      licked the snapping strawberry confection. Lyla devolved into giggles as
      the multicolored cat, unprepared for the &quot;snap&quot; of the treat,
      pawed at his face while his coat became a light show that would have
      shamed a rainbow. Myles joined in on the laughter, drawn by the
      ridiculousness of the scene before him.
    </p>
    <p>
      &quot;But what do you actually do in it?&quot; Myles asked once the
      Scufy's tongue had recovered (he was now giving the black and red
      suspicious gaze to Lyla's ice cream as well as to Myles).
    </p>
    <p>
      &quot;You find your enemies,&quot; Lyla said seriously, pausing to lick
      her ice cream. &quot;And then you hex them. Every kid with a wand in the
      Lower Alley plays, 'cept some of the girls, and the older boys play
      separate, of course. I won today, even though Oli and Thomas played; and
      they're second years at school.&quot;
    </p>
    <p>
      Lyla got into an animated description of how she and Scuffy had conquered
      the streets of the Lower Alley, an entertaining endeavor that fully
      explained hexem. Hexem was a game that the kids in the Lower Alley played,
      a neighborhood wide free for all in which hexes were exchanged and you
      lost when you surrendered or could no longer move or cast spells. It was
      bound only by chalk marked outlines considered outside of household
      premises where the Trace magic wouldn't be registered to a wizarding
      household. The way Lyla explained it, dodging in and out of chalk lines
      was a high stakes part of the game, and performing spells outside of them
      forfeited the game and risked a visit from a Ministry official.
    </p>
    <p>
      Her victory today had involved rooftop chases and a number of won duels,
      some of which had left her in much worse shape than she had come into the
      shop with. She had dealt with reversed knees, had shed her shoes due to a
      sticking charm cleverly aimed at the floor below that she didn't have time
      to clear (she was still shoeless), and severely enlarged toenails. The
      rule was that if you threw a hex you had to be able to cast the
      counter-spell afterwards to clear the effects, but Lyla had run off to get
      Scuffy's leg healed before getting some of the hexes treated. Scuffy's
      injury had come from jumping onto an opponent that was sneaking up behind
      Lyla from a rooftop and Myles interpreted that the use of pets was a legal
      grey area in Lower Alley hexem.
    </p>
    <p>
      &quot;Did you enjoy the ice cream?&quot; Ms. Lenore asked as she joined
      them at the table, having extricated herself from conversation with the
      overly talkative witch that had called her over. Their ice cream was all
      but gone and Lyla had finished the story of her hexem game.
    </p>
    <p>
      &quot;It was amazing ma'm,&quot; Lyla beamed at Ms. Lenore and Myles
      nodded in agreement. &quot;Thank you!&quot;
    </p>
    <p>
      They left a couple of minutes later. Lyla, excited about going to Hogwarts
      in just a couple of weeks, pestered Ms. Lenore with questions about the
      school the whole way back. She didn't seem to mind, however, answering
      each question patiently:
    </p>
    <p>&quot;What house were you in at Hogwarts?&quot;</p>
    <p>&quot;Hufflepuff.&quot;</p>
    <p>&quot;What's Hufflepuff like?&quot;</p>
    <p>
      &quot;It's a house of lasting friends and great times. I couldn't imagine
      being sorted differently.&quot;
    </p>
    <p>&quot;Is the common room big?&quot;</p>
    <p>&quot;Large enough, though I never saw the other common rooms.&quot;</p>
    <p>
      &quot;Do you really get to fight against trolls in Defence Against the
      Dark Arts?&quot;
    </p>
    <p>&quot;I don't know where that rumor started.&quot;</p>
    <p>&quot;Does the Defence professor really die every year?&quot;</p>
    <p>
      &quot;They don't last more than a year as a teacher, but few of them
      die.&quot;
    </p>
    <p>&quot;Did you fight in the Battle for Hogwarts?&quot;</p>
    <p>
      &quot;I was there.&quot; Ms. Lenore responded to the last question after a
      pause, in a tone that brokered no further questions and a grim mood.
    </p>
    <p>
      Myles was learning a lot about the world outside of the Orphanage, details
      and wonders that hadn't been described in the few texts he had read in the
      long bookshelf of the Library. But he still felt constantly out of the
      loop and knew nothing about the battle Lyla had referenced and little
      about the often mentioned Hogwarts.
    </p>
    <p>
      The rest of their walk passed in silence and Lyla said her farewells when
      they reached Beth's. She gave Ms. Lenore a hug, darting into her arms, and
      the composed woman let out a rare full and genuine smile as she hugged the
      young girl back. Lyla thanked Ms. Lenore again, then released from the
      embrace and looked Myles in the eyes.
    </p>
    <p>
      &quot;By Scuffy's hue and witch's word, we owe you one.&quot; She said
      solemnly, holding out her hand for him to shake. Myles, quite confused by
      the girl's dramatics, shook her hand. He guessed that she was referring to
      him healing Scuffy, though Ms. Lenore would have done a much better job.
      Lyla left, Scuffy and her walking energetically down towards Lower Alley.
      Ms. Lenore gave Myles a knowing and slightly mischievous smile, her eyes
      twinkling with amusement, and Myles blushed without knowing why.
    </p>
    <p>
      The re-entered Beth's, the sign magically flipping from closed to open as
      Ms. Lenore entered the shop. They fell into the comfortable routine they
      had formed over the past few days: tutoring in healing, treating clients,
      and managing the store. Myles was beginning to feel comfortable here,
      beginning to feel at home in the herb scented shop. The situation,
      however, would not last through the upcoming weekend.
    </p>
  </div>
);

export default three;
